import { Typography } from '@material-ui/core'
import useStyles from '../styles'
import { isLastStep } from '../utils'
import InfoWrapper from './InfoWrapper'

const AccessInstructions = ({ record }) => {
  if (record.fiche_adresse === null) return null
  if (isLastStep(record) === true) return null
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.beginBar}></div>
      <Typography classeName={classes.title} gutterBottom>
        Informations d'accès
      </Typography>
      <InfoWrapper title="Adresse" value={record.fiche_adresse} />
      <InfoWrapper
        title="Complément adresse"
        value={record.fiche_complement_adresse}
      />
      <InfoWrapper title="Codes d'accès" value={record.fiche_codes_acces} />
      <InfoWrapper title="Interphones" value={record.fiche_interphones} />
      <InfoWrapper title="Vigik" value={record.fiche_vigik} />
    </div>
  )
}
export default AccessInstructions
